<div class="sf-page">

  <!-- Header -->
  <header class="sf-page__header">
    <div class="sf-page__header-left">
      <div class="sf-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
        </svg>
      </div>
      <div>
        <h1 class="sf-page__title">Sources de financement</h1>
        <p class="sf-page__desc">Gérez les sources de financement de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter une source"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openSourceFinancementModal()"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="sf-card">
    @if (isLoading) {
      <div class="sf-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="sf-card__toolbar">
        <div class="sf-card__toolbar-left">
          <span class="sf-badge">{{ sourceFinancements.length }}</span>
          <span class="sf-card__count">
            enregistrement{{ sourceFinancements.length > 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      @if (!sourceFinancements.length) {
        <div class="sf-empty">
          <div class="sf-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <line x1="12" y1="1" x2="12" y2="23"/>
              <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
            </svg>
          </div>
          <p class="sf-empty__title">Aucune source de financement</p>
          <p class="sf-empty__hint">Commencez par en ajouter une en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table
          [columns]="tableSourceFinancement"
          [data]="sourceFinancements"
          [actions]="rowActions"
        />
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="sf-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        (clicked)="onEditSourceFinancement(item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal Ajout / Édition -->
<app-modal
  [isVisible]="showAddSourceFinancementModal"
  [title]="isEditing ? 'Modifier la source' : 'Nouvelle source de financement'"
  (closeEvent)="closeSourceFinancementModal()"
>
  <form [formGroup]="sourceFinancementForm" (ngSubmit)="saveSourceFinancement()" class="sf-form">

    @if (isEditing && editingSourceFinancement) {
      <div class="sf-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingSourceFinancement.libelle }}</strong>
      </div>
    }

    <div class="sf-form__field">
      <app-input
        label="Source de financement"
        placeholder="Ex : Fonds propres"
        type="text"
        formControlName="libelle"
      />
      @if (sourceFinancementForm.get('libelle')?.invalid && (sourceFinancementForm.get('libelle')?.dirty || sourceFinancementForm.get('libelle')?.touched)) {
        <span class="sf-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le libellé est requis.
        </span>
      }
    </div>

    <div class="sf-form__actions">
      <app-ui-button
        label="Annuler"
        variant="ghost"
        size="md"
        type="button"
        (clicked)="closeSourceFinancementModal()"
      ></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || sourceFinancementForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>